import {  FavoriteBorder,  MoreVert, ThumbUpAlt } from '@material-ui/icons';
import React, { useContext, useEffect } from 'react';
import "./post.css"
import {  useState } from "react";
import { format } from "timeago.js"
import axios from 'axios';
import {Link} from "react-router-dom"
import { AuthContext } from '../../context/AuthContext';
import API from '../../utils/apiurl';
import PF from '../../utils/images'
function Post({post}) {
 
    const [ like , setLike] = useState(post.likes.length);
    const [ isliked, setIsliked ] = useState(false);
    const [ user, setUser ] = useState({});

    const {user: currentUser}  = useContext(AuthContext);
    const authAxios = axios.create({
        baseURL: API,
        headers:{
            Authorization: `Bearer ${localStorage.token}`
        }
    })
 

    useEffect(() => {
        setIsliked(post.likes.includes(currentUser._id))
    },[currentUser._id, post.likes])

    
    useEffect(()=>{
        const fetchUser  = async () => {
            const res = await authAxios.get(`/users?userID=${post.userID}`);
            console.log(res);
            setUser(res.data);
        }
        fetchUser();    
    },[post.userID]);


    const likeHandler = () => {
        try {
            const likes = authAxios.put("/posts/like/"+post._id,{userID: currentUser._id})
            setLike(isliked ? like-1 : like+1)
            setIsliked(!isliked );
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div className = "post">
            <div className="postWrapper">
                <div className="postTop">
                    <div className="postTopLeft">
                        <Link to = {`/profile/${user.username}`}>
                            <img src={user.profilePicture ? PF+user.profilePicture: PF+"1.jpg"} alt="DP" className="postProfileImg" />
                        </Link>
                        <span className="postUserName">{user.username}</span>
                        <span className="postDate">{format(post.createdAt)}</span>
                    </div>
                    <div className="postTopRight">
                        <MoreVert />
                    </div>
                </div>
                <div className="postCenter">
                    <span className="postText">{post?.desc}</span>
                    <img 
                        src={PF+post.images || PF+"1.jpg" } 

                        alt="post1" 
                        className="postImg" 
                    />
                </div>
                <div className="postBottom">
                    <div className="postBottomLeft">
                        <button className="likeIcon" onClick={likeHandler}>
                            <ThumbUpAlt />
                        </button>
                        <button className="likeIcon" onClick={likeHandler}>
                            <FavoriteBorder />
                        </button>
                        <span className="postLikeCounter">
                            {like}
                        </span>
                    </div>
                    <div className="postBottomRight">
                        <span className="postCommentText">
                            {post.comment}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Post;